export enum ModalMode {
    DETAIL = 'DETAIL',
    EDIT = 'EDIT'
}
